// 停止理由を独立して保持し、ホバー解除で「手動停止」を誤って解除しない。
export class SlideshowClock {
  constructor(next, delay, timers = globalThis) {
    this.next = next;
    this.delay = delay;
    this.timers = timers;
    this.reasons = new Set(['offscreen']);
    this.timer = null;
    this.destroyed = false;
  }

  pause(reason) {
    this.reasons.add(reason);
    this.clear();
  }

  resume(reason) {
    if (this.destroyed || !this.reasons.delete(reason) || this.reasons.size) return;
    this.next();
    this.reset();
  }

  clear() {
    if (this.timer !== null) this.timers.clearTimeout(this.timer);
    this.timer = null;
  }

  reset() {
    this.clear();
    if (this.destroyed || this.reasons.size) return;
    this.timer = this.timers.setTimeout(() => {
      this.timer = null;
      this.next();
      this.reset();
    }, this.delay);
  }

  destroy() { this.destroyed = true; this.clear(); }
}
